import React from 'react';
import { LoadingButton } from './LoadingButton';

export type DateSelectorProps = {
  value?: string | number | Date;
  onChange?: (_evt: React.ChangeEvent<HTMLInputElement>) => void;
  onConfirm?: (_evt: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  isLoading?: boolean;
  buttonText?: string;
  className?: string;
  inputProps?: React.HTMLProps<HTMLInputElement>;
  label?: string;
};

export const DateSelector: React.FC<DateSelectorProps> = ({
  className = '',
  onChange,
  inputProps = {},
  onConfirm,
  isLoading,
  buttonText,
  label = 'Date',
}) => {
  return (
    <div className={`input-group ${className}`}>
      <label className="input-group-text">{label}</label>
      <input
        onChange={onChange}
        type="date"
        className="form-control form-control-sm"
        {...inputProps}
      />
      {buttonText && (
        <LoadingButton
          className="btn btn-primary"
          onClick={onConfirm}
          isLoading={isLoading}
        >
          {buttonText}
        </LoadingButton>
      )}
    </div>
  );
};
